import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const Download = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.995 16.4572C11.8349 16.4572 11.6749 16.3972 11.5548 16.2771H11.5748L7.07255 11.7749C6.83243 11.5348 6.83243 11.1346 7.07255 10.8944C7.31267 10.6543 7.71287 10.6543 7.95299 10.8944L11.3847 14.3262V2.62031C11.3847 2.28014 11.6648 2 12.005 2C12.3452 2 12.6253 2.28014 12.6253 2.62031V14.3262L16.057 10.8944C16.2972 10.6543 16.6974 10.6543 16.9375 10.8944C17.1776 11.1346 17.1776 11.5348 16.9375 11.7749L12.4352 16.2771C12.3152 16.3972 12.1551 16.4572 11.995 16.4572ZM20.7594 19.0685C20.7594 18.7284 21.0395 18.4482 21.3797 18.4482C21.7199 18.4482 22 18.7284 22 19.0685V21.3797C22 21.7199 21.7199 22 21.3797 22H2.62031C2.28014 22 2 21.7199 2 21.3797V19.0685C2 18.7284 2.28014 18.4482 2.62031 18.4482C2.96048 18.4482 3.24062 18.7284 3.24062 19.0685V20.7494H20.7594V19.0685Z"
    />
  </svg>
)

export default withDefaultStyles(Download)
